import { Injectable } from '@angular/core';
import { NoticeService } from './notice.service';
import { Globals } from './globals';

/**
 * 공지사항에 관련된 정보
 */
@Injectable()
export class NoticeController {

  /**
   * 센터번호
   */
  private $centerNum: number[];

  /**
   * 읽지 않은 공지사항이 있는지 여부
   */
  private $hasNew: boolean;

  /**
   * 사용자가 읽은 공지사항 목록
   */
  private $readNoticeNums: any[] = [];

  constructor(
    private $noticeService: NoticeService, g: Globals) {

    this.$centerNum = g.centerNums;

    // 읽지 않은 공지사항이 있으면 표시
    this.newNoticeUpdate();
  }

  /**
   *  해당 공지사항을 사용자가 읽었는지 여부
   */
  private $isRead(num: number): boolean {
    return this.$readNoticeNums.indexOf(num) !== -1;
  }

  /**
   * 해당 날짜가 지금으로부터 한달전에 포함되는지 여부
   */
  private $isInAMonth(date: string): boolean {
    // 현재 시간
    const preMonth = new Date(new Date().getTime());
    // 한달 전으로 세팅
    preMonth.setMonth(preMonth.getMonth() - 1);

    return new Date(date) >= preMonth;
  }

  /**
   * 공지사항목록에서 한달이 지나지 않고 사용자가 읽지 않은 공지사항을 구별해서 반환
   */
  private async newNotice() {
    // 공지사항 전체 목록
    const centers = this.$centerNum.join(',');
    const noticeList = await this.$noticeService.notice(centers);
    // 사용자가 읽은 공지사항 목록
    const read = await this.$noticeService.readNotice();
    // 사용자가 읽은 공지사항 식별번호 목록
    this.$readNoticeNums = read.map(v => v.crm_num);

    // 공지사항목록에서 한달이 지나지 않고 사용자가 읽지 않은 공지사항을 구별
    return noticeList.map((n) => {
      n['isNew'] = this.isNew(n);
      return n;
    });
  }

  /**
   * 읽지 않은 공지사항이 있으면 표시
   */
  newNoticeUpdate() {
    this.newNotice().then(
        data => this.$hasNew = !!data.find(notice => notice['isNew']),
        err => console.log(err),
    );
  }

  /**
   * 해당 공지사항을 사용자가 읽지 않고 지금으로부터 한달전 공지사항인지 여부
   */
  isNew(n: any): boolean {
    return !this.$isRead(n.crm_num) && this.$isInAMonth(n.crm_date);
  }

  /**
   * 읽지 않은 공지사항이 있는지 여부 반환
   */
  hasNew(): boolean {
    return this.$hasNew;
  }
}
